module.exports = "implementation 'com.hudl:uniform-ui:X.XX.XX'\n"